// 我的预约
import * as React from "react";
import Layout from "../Layout";
import Content from "./Content";
import InfoLayout from "../UserCenter/components/Layout";
import { useSelector } from "react-redux";
import { RootState } from "../../store/configureStore";

const Reservation: React.FC = () => {
  const {
    breadcrumbs = [
      {
        url: "/",
        title: "首页",
      },
      {
        url: "/account/experience",
        title: "预约",
      },
    ],
  } = useSelector((state: RootState) => state.ReservationPage);

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <InfoLayout>
        <Content />
      </InfoLayout>
    </Layout>
  );
};

export default Reservation;
